import { useEffect, useState } from 'react';

const secondsToWaitBeforeApply = 3;

/**
 * An extremely dirty way to synchronize today aggregations and live data
 */
export default function useCompletedCount(acceptedCount: number, connectedCount: number): number {
    const [completedCount, setCompletedCount] = useState(0);

    useEffect(
        () => {
            let timeout: NodeJS.Timeout | undefined;

            setCompletedCount(currentVal => {
                if (acceptedCount <= 0) {
                    // to allow midnight reset
                    return 0;
                }
                const newVal = Math.max(0, acceptedCount - connectedCount);

                // to avoid the short lived decreased completed count
                if (newVal < currentVal) {
                    timeout = setTimeout(() => setCompletedCount(newVal), secondsToWaitBeforeApply * 1000);
                    return currentVal;
                }

                return newVal;
            });

            if (timeout) {
                return () => clearTimeout(timeout as NodeJS.Timeout);
            }
        },
        [acceptedCount, connectedCount],
    );

    return completedCount;
}